import { WAIT_PORTAL_TIMEOUT, WAIT_PORTAL_DELAY } from './constants';
import { Logger } from '../../logger';

export class SfPortal {
  static getSfPortal() {
    return window.manomano?.portal?.eventManager;
  }

  static getSfPortalListener() {
    let sfPortalListener = null;
    return (() => {
      if (!sfPortalListener) {
        const sfPortal = SfPortal.getSfPortal();
        if (typeof sfPortal?.on === 'function') {
          sfPortalListener = sfPortal.on.bind(sfPortal);
        }
      }

      return sfPortalListener;
    })();
  }

  static getSfPortalTriggerer() {
    let sfPortalTriggerer = null;
    return (() => {
      if (!sfPortalTriggerer) {
        const sfPortal = SfPortal.getSfPortal();
        if (typeof sfPortal?.trigger === 'function') {
          sfPortalTriggerer = sfPortal.trigger.bind(sfPortal);
        }
      }

      return sfPortalTriggerer;
    })();
  }

  constructor() {
    this.waitForSfPortalPromise = null;
  }

  listenFromSfPortal(eventName, callback) {
    const doListen = () => {
      const listener = SfPortal.getSfPortalListener();
      if (!listener) {
        return false;
      }

      listener(eventName, callback);
      return true;
    };

    if (doListen()) {
      return Promise.resolve();
    }

    return this.waitForSfPortal()
      .then(doListen)
      .catch(error => {
        const message = `${error}: unable to listen "${eventName}" event from sf portal`;
        Logger.error(message);
      });
  }

  triggerToSfPortal(eventName, ...args) {
    const dotrigger = () => {
      const triggerer = SfPortal.getSfPortalTriggerer();
      if (!triggerer) {
        return false;
      }

      triggerer(eventName, ...args);
      return true;
    };

    if (dotrigger()) {
      return Promise.resolve();
    }

    return this.waitForSfPortal()
      .then(dotrigger)
      .catch(error => {
        const message = `${error}: unable to trigger "${eventName}" event to sf portal`;
        Logger.error(message);
      });
  }

  waitForSfPortal() {
    if (this.waitForSfPortalPromise) {
      return this.waitForSfPortalPromise;
    }

    let timer;
    let timeoutTimer;

    const killTimer = () => {
      clearTimeout(timer);
      timer = null;
    };

    const killTimeoutTimer = () => {
      clearTimeout(timeoutTimer);
      timeoutTimer = null;
    };

    const killAllTimers = () => {
      killTimer();
      killTimeoutTimer();
    };

    this.waitForSfPortalPromise = new Promise((resolve, reject) => {
      const waitForSfPortalIterator = () => {
        if (timer) {
          return;
        }

        timer = setTimeout(() => {
          killTimer();

          const sfPortal = SfPortal.getSfPortal();
          if (sfPortal) {
            killTimeoutTimer();
            this.waitForSfPortalPromise = null;

            resolve();
          } else {
            waitForSfPortalIterator();
          }
        }, WAIT_PORTAL_DELAY);

        if (!timeoutTimer) {
          timeoutTimer = setTimeout(() => {
            killAllTimers();
            // eslint-disable-next-line prefer-promise-reject-errors
            reject(
              `Timeout while waiting for portal to be ready (${WAIT_PORTAL_TIMEOUT})`,
            );
          }, WAIT_PORTAL_TIMEOUT);
        }
      };

      waitForSfPortalIterator();
    });

    return this.waitForSfPortalPromise;
  }
}

export const sfPortal = new SfPortal();
export const listenFromSfPortal = (eventName, callback) => {
  return sfPortal.listenFromSfPortal(eventName, callback);
};
export const triggerToSfPortal = (eventName, ...args) => {
  return sfPortal.triggerToSfPortal(eventName, ...args);
};
